import { compose } from 'redux'
import { connect } from 'react-redux'
import registerReduxModal from 'components/common/hoc/registerReduxModal'
import * as actions from './actions'
import { APPOINTMENT_SUCCESS_MODAL } from '../constants'
import AppointmentSuccessModal from './AppointmentSuccessModal'
import { withProps } from 'recompose'
import { ACCOUNT_REGISTRATION_FORM } from 'constant'
import { getCurrentStore } from 'selectors'
import {
  composeFormattedPhoneNumberFromObject,
  getPhoneNumberFromObjectWithPrefix
} from 'helpers/phone-number'
import withHandlePhoneLinkClick from 'components/common/hoc/withHandlePhoneLinkClick'

const mapStateToProps = state => ({
  myStore: getCurrentStore(state)
})

const withProfile = withProps(({ profilePopulationData }) => ({
  registrationLocation: { pathname: ACCOUNT_REGISTRATION_FORM, state: { profilePopulationData }}
}))

const withStoreDetails = withProps(({
  myStore: {
    storeNumber,
    address,
    storeDetailsUrl,
    owner
  } = {}
}) => ({
  storeNumber,
  storeAddress: address,
  locationPhoneNumberFormatted: composeFormattedPhoneNumberFromObject(address.phoneNumber),
  locationPhoneNumberUrl: getPhoneNumberFromObjectWithPrefix(address.phoneNumber),
  storeDetailsUrl,
  owner
})
)

export default compose(
  registerReduxModal({ name: APPOINTMENT_SUCCESS_MODAL }),
  connect(mapStateToProps, actions),
  withProfile,
  withStoreDetails,
  withHandlePhoneLinkClick
)(AppointmentSuccessModal)
